module.exports = __webpack_public_path__ + "static/img/a061.34cb090.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a061.jpg
// module id = r6TC
// module chunks = 0